<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { InfoIcon } from '../../assets/icons/InfoIcon';
	import { Tooltip, type TooltipPlacement } from '../Tooltip';

	let {
		color = 'gray-500',
		dataCy,
		placement = 'top',
		content = '',
		classes = {},
		...rest
	}: Props = $props();

	interface Props {
		class?: string;
		color?: string | undefined;
		dataCy: string;
		placement?: TooltipPlacement;
		content?: string;
		classes?: { tooltipClasses?: { content?: string } };
	}

	let dataCyPrefix = $derived(`${dataCy}-info`);
</script>

<Tooltip classes={classes?.tooltipClasses} dataCy={dataCyPrefix} {content} {placement}>
	<InfoIcon class={twMerge('h-5 w-5', rest.class)} {color} />
</Tooltip>
